import type { SliceCreator, ChatbotSlice } from "@/state/types";

export const createChatbotSlice: SliceCreator<ChatbotSlice> = (set) => ({
  chatbotModalOpen: false,
  setChatbotModalOpen: (open) =>
    set({ chatbotModalOpen: open }, false, "chatbot/setChatbotModalOpen"),

  chatbotAuthPayload: null,
  setChatbotAuthPayload: (payload) =>
    set(
      { chatbotAuthPayload: payload },
      false,
      "chatbot/setChatbotAuthPayload",
    ),

  chatbotStatus: "idle",
  chatbotError: null,
  setChatbotStatus: (status, err = null) =>
    set(
      { chatbotStatus: status, chatbotError: err },
      false,
      "chatbot/setChatbotStatus",
    ),

  chatbotInjected: false,
  setChatbotInjected: (v) =>
    set({ chatbotInjected: v }, false, "chatbot/setChatbotInjected"),

  resetChatbot: () =>
    set(
      {
        chatbotModalOpen: false,
        chatbotAuthPayload: null,
        chatbotStatus: "idle",
        chatbotError: null,
        chatbotInjected: false,
      },
      false,
      "chatbot/resetChatbot",
    ),
});
